export default __webpack_public_path__ + "static/media/map.50981918.svg";